import { type HealthStatus, useHealthCheck } from '@/hooks/useHealthCheck';
import React, { createContext, useContext } from 'react';

interface HealthContextType extends HealthStatus {
  checkHealth: () => void;
}

const HealthContext = createContext<HealthContextType | undefined>(undefined);

interface HealthProviderProps {
  children: React.ReactNode;
}

export const HealthProvider: React.FC<HealthProviderProps> = ({ children }) => {
  const healthData = useHealthCheck();

  return <HealthContext.Provider value={healthData}>{children}</HealthContext.Provider>;
};

export const useHealth = (): HealthContextType => {
  const context = useContext(HealthContext);
  if (context === undefined) {
    throw new Error('useHealth must be used within a HealthProvider');
  }
  return context;
};
